<template>
    <DForm
        @submit.prevent="submitForm"
    >
        <DCard
            padding
            :title="__('tools.testing.mocking.title')"
        >
            <DFormRow
                :label="__('tools.testing.mocking.label')"
                :is-required="true"
                :hint="__('tools.testing.mocking.helptext')"
            >
                <DSwitch
                    id="activate_cloudpit_mocking"
                    v-model="form.cloudpit_mocking"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
        </DCard>
        <DFormControls
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const props = defineProps({
    testingConfiguration: {
        type: Object,
        default: () => { return {} }
    }
})

const form = useForm({
    cloudpit_mocking: props.testingConfiguration?.cloudpit_mocking ?? false
})

const submitForm = () => {
    form.post(route('tools.mocking.store'))
}
</script>
